import { parse } from "exifr"

function text(value: unknown): string {
 if (typeof value === "string") return value.replace(/[\u0000-\u001f\u007f]/g, " ").replace(/\s+/g, " ").trim()
 if (Array.isArray(value)) return value.map(text).find(Boolean) || ""
 if (value && typeof value === "object") {
  const localized = value as Record<string, unknown>
  return text(localized["x-default"]) || text(localized.value) || text(localized["rdf:value"])
 }
 return ""
}

export async function readEmbeddedImageDescription(file: File): Promise<string> {
 try {
  const metadata = await parse(file, { iptc: true, xmp: true, exif: true, gps: false, icc: false, mergeOutput: false })
  // Prefer the press-photo caption, as WordPress does, then XMP and EXIF descriptions.
  const candidates = [metadata?.iptc?.Caption, metadata?.dc?.description, metadata?.xmp?.description,
   metadata?.ifd0?.ImageDescription, metadata?.exif?.UserComment, metadata?.png?.Description]
  return (candidates.map(text).find(Boolean) || "").slice(0, 140)
 } catch {
  // Metadata is optional; unsupported files or malformed tags still allow manual entry.
  return ""
 }
}
